import { useEffect, useState } from "react";
import { MessageService, UploadService } from "../../../services";
import "./style.css";
import { decodeJWT } from "../../../utils/commonFns";
import Toaster from "../../Toaster/Toster";
import Docupload from "../../Docupload/Docupload";

interface ProductListProps {
    formData: any;
    report: any;
    rowData: any;
    setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const ProductListUpload: React.FC<ProductListProps> = ({
    formData,
    report,
    rowData,
    setFormData,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [filesInfo, setFilesInfo] = useState<any[]>([]);
    const [isFolderPath, setIsFolderPath] = useState<boolean>(false);
    const [isDocSuccess, setIsDocSuccess] = useState<boolean>(false);
    const [isDocFail, setIsDocFail] = useState<boolean>(false);
    const [showToster, setShowToster] = useState<boolean>(false);
    const [tosterInfo, setTosterInfo] = useState<{ type: "success" | "error" | "warning", message: string }>({ type: "success", message: "" });

    const fetchUploadedFile = async () => {
        console.log("group upload", rowData)
        if (rowData?.opportunityShareFileId) {
            setIsFolderPath(true);
            await UploadService.getUploads(rowData?.opportunityShareFileId)
                .then(response => {
                    if (response) {
                        setFilesInfo(response);
                    } else setFilesInfo([]);
                })
                .catch(error => {
                    console.log(error)
                    setFilesInfo([]);
                })

        }
    };

    useEffect(() => {
        fetchUploadedFile()
    }, [rowData])

    const onFileUpload = async (files: File[]) => {
        if (isFolderPath) {

            // all files should be in valid format i.e .pdf,.txt,.doc,.xls
            const validFileTypes = ["application/pdf", "text/plain", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
            const validFiles = files.filter((file) => validFileTypes.includes(file.type));
            if (validFiles.length !== files.length) {
                setTosterInfo({ type: "error", message: `The file type you uploaded is not supported, please upload a .pfd, .xls, .txt or .docx.` });
                setShowToster(true);
                setIsDocFail(true);
                setTimeout(() => {
                    setIsDocFail(false);
                }, 4000)
                return;
            } else if (files.every(file => file.size > 10 * 1024 * 1024 + 5)) {
                setTosterInfo({ type: "error", message:  `This file exceeds the max allowed file size. Please upload a file that does not exceed 10mb.` });
                setShowToster(true);
                setIsDocFail(true);
                setTimeout(() => {
                    setIsDocFail(false);
                }, 4000)
                return;
            } else {
                // all files should be in valid format i.e .pdf,.txt,.doc,.xls
                setIsLoading(true);
                for (const file of files) {
                    const sharefileId = report.ShareFile_Draft_Folder__c?.split("/").pop();
                    await UploadService.addUploads(file, rowData?.opportunityShareFileId)
                        .then(response => {
                            setIsDocSuccess(true);
                            fetchUploadedFile();
                            setTosterInfo({ type: "success", message: `File uploaded successfully.` });
                            setShowToster(true)
                            setIsLoading(false);

                            setTimeout(() => {
                                setIsDocSuccess(false);
                            }, 4000)

                        })
                        .catch(error => {
                            setIsDocFail(true);
                            setTosterInfo({ type: "error", message: `It seems there was an error on our end preventing your upload from completing, please try uploading the document again.` });
                            setShowToster(true)
                            setIsLoading(false);

                            setTimeout(() => {
                                setIsDocFail(false);
                            }, 4000)
                        })
                }
            }

        } else {
            setTosterInfo({ type: "error", message: `Something went wrong on our end, please try uploading your document again.` });
            setShowToster(true)
        }
    };

    return (
        <div className="p-4">
            <Docupload
                filesInfo={filesInfo}
                visible={false}
                disabled={false}
                sidebyside={true}
                isFolderPath={isFolderPath}
                isDocSuccess={isDocSuccess}
                isDocFail={isDocFail}
                onFileUpload={onFileUpload} />
            <Toaster
                type={tosterInfo.type}
                show={showToster}
                setShow={setShowToster}
                message={tosterInfo.message}
            />
        </div>
    )
}

export default ProductListUpload